export default "__VITE_ASSET__BzJNa9ql__"